import { useQuery } from '@tanstack/react-query'
import { TAlertRuleDefinition } from 'shared/types'
import { api } from '..'

export const getAlertRuleDefinition = (
  alertRuleId: string,
  signal?: AbortSignal,
) =>
  api
    .get<TAlertRuleDefinition>(`/v1/alert-rules/${alertRuleId}/definition`, {
      signal,
      timeout: 15000,
    })
    .then(({ data }) => data.items)

export const updateAlertRuleDefinition =
  (alertRuleId: string) => (data: TAlertRuleDefinition) =>
    api.put(`/v1/alert-rules/${alertRuleId}/definition`, data)

export const useGetAlertRuleDefinition = (
  alertRuleId?: string,
  options?: { enabled?: boolean },
) => {
  if (!alertRuleId) throw new Error('Missing alertRuleId')

  return useQuery({
    queryFn: ({ signal }) => getAlertRuleDefinition(alertRuleId, signal),
    queryKey: ['alertRule', alertRuleId, 'definition'],
    enabled: options?.enabled !== false,
    retry: false,
  })
}
